import * as yup from 'yup';

import { requiredNumberField } from '@blockpulse3/data/shared';

export const schema = yup.object({
  investAmount: requiredNumberField,
  fundsSourceCertificate: yup.string().optional(),
});
